import { skipToken, useQuery } from '@tanstack/react-query';
import { getV1CompaniesCompanyIdTreadAgentSkillsId } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { TreadAgentSkill } from '~hooks/useTreadAgent/models';
import { TREAD_AGENT_SKILLS_QUERY_KEY } from '~queries/treadAgentQueryKeys';
import connection from '~services/connectionModule';
import { Nullable } from '~types/Nullable';

export default function useTreadAgentSkillQuery(
  companyId: Nullable<string>,
  skillId: Nullable<string>,
) {
  return useQuery({
    queryKey: [TREAD_AGENT_SKILLS_QUERY_KEY, companyId, skillId],
    queryFn:
      companyId && skillId
        ? async ({ signal }) => {
            try {
              const response = await getV1CompaniesCompanyIdTreadAgentSkillsId({
                path: { 'company-id': companyId, id: skillId },
                signal,
              });

              return TreadAgentSkill.parse(response.data.data);
            } catch (error) {
              connection.handleRequestError(
                error,
                t('error_messages.tread_agent.failed_to_fetch_skill'),
              );
              throw error;
            }
          }
        : skipToken,
    gcTime: 0,
  });
}
